<template>
  <div class="publicizeList">
    <div class="bgc">
      <div class="bx-content">
        <div class="banner">
          <div class="weizhi">
            <i class="iconfont icon-dizhi"></i> 当前位置：首页 > {{name}} > 详情
          </div>
          <div class="page-cancel" @click="$router.go(-1)">
            <i class="icon iconfont icon-jiantouzuo1"></i>返回
          </div>
        </div>

        <div class="list-box margin-top">
          <div class="title">{{detail.title}}</div>

          <div class="flex justify-center align-center desc">
            <div class="time" v-if="detail.author">
              <i class="iconfont icon-zuozhe"></i>
              作者：{{detail.publish_time}}
            </div>
            <div class="time">
              <i class="iconfont icon-shijian6"></i>
              时间：{{detail.publish_time}}
            </div>
            <div class="time" v-if="detail.resource">
              <i class="iconfont icon-laiyuan1"></i>
              来源：{{detail.resource}}
            </div>
          </div>

          <div class="content" v-html="detail.content"></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {
  org_article_detail
} from "@/api";
export default {
  name: "policyList",
  data() {
    return {
      id: '',
      name: '',
      detail:{
        title: '',
        publish_time: '',
        content: ''
      }
    }
  },
  components: {},
  created() {
    this.id = this.$route.query.id
    this.name = this.$route.query.name
    this.init()
  },
  methods: {
    async init(){
      let _data = await org_article_detail(this.id);
      if(_data.status == 200) {
        this.detail = _data.data
      }
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      background: #ffffff;
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 80px 30px;
      .content {
        width: 100%;
        padding: 50px 100px;
        font-size: 18px;
        color: #333640;
        line-height: 30px;
        img {
          max-width: 100%;
          display: block;
          margin: 10px auto;
        }
      }
      .title {
        width: 100%;
        text-align: center;
        font-size: 36px;
        color: #293340;
      }
      .desc {
        width: 100%;
        height: 90px;
        border-bottom: 1px solid #cecece;
        border-top: 1px solid #cecece;
        margin-top: 30px;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
          padding: 0 15px;
          i {
            font-size: 23px;
            color: #000000;
            margin-right: 4px;
          }
        }
      }
    }
    .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      span {
        font-size: 18px;
        color: #428ffb;
        width: 105px;
        height: 45px;
        border-radius: 22px;
        border: solid 1px #428ffb;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #428ffb;
        }
      }
    }
  }
  .banner {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #dfe1f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      font-size: 16px;
      letter-spacing: 1px;
      color: #999999;
      i {
        font-size: 18px;
        color: #999999;
      }
    }
  }
}
</style>


